import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import packageJson from '../../package.json';
import { SupportedAppVersions } from '../pages/types';
import { ApiResponseType } from '../shared/types/apiResponse.type';

export const checkAppVersion = async (): Promise<ApiResponseType<SupportedAppVersions>> => {
  const { data: consultationData } = await HttpHandler({
    method: 'POST',
    url: `${environment.APP_VERSIONS_URL}/api-version/check-support-version`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      appVersion: packageJson.version,
      apiVersion: +packageJson['api-version'],
      appType: 'client',
    },
  });

  return consultationData;
};
